import React from 'react'

import { FlexBox } from '@vp/swan'
import { PriceDisplay } from '@vp/price-platform'

import { usePricingContext } from '../../../root/contexts/PricingContext'
import { useAppState } from '../../../root/contexts/AppContext'
import { useProject } from '../../../root/contexts/ProjectContext'

type PricingSummaryProps = {
  totalQuantity: number
}

export const PricingSummary: React.FC<PricingSummaryProps> = ({ ...props }: PricingSummaryProps) => {
  const { isAppStateInitialized } = useAppState()
  const { productKey, productVersion, lowestPriceAttributes } = useProject()

  const { isInitialized: isPricingContextInitialized } = usePricingContext()

  const isLoading = !isPricingContextInitialized || !isAppStateInitialized

  return (
    <FlexBox className="pricing-summary" pt={2}>
      {!isLoading && (
        <PriceDisplay productId={productKey} version={productVersion} selections={{ ...lowestPriceAttributes, quantity: String(props.totalQuantity) }} />
      )}
    </FlexBox>
  )
}
